import { z } from 'zod';

/**
 * Schema for warehouse group form data
 */
export const warehouseGroupSchema = z.object({
  ma_nhom: z.string().min(1, 'Mã nhóm là bắt buộc'),
  ten_phan_nhom: z.string().min(1, 'Tên nhóm là bắt buộc'),
  ten2: z.string().optional().nullable(),
  trang_thai: z.string().default('1')
});

export type WarehouseGroupFormValues = z.infer<typeof warehouseGroupSchema>;

/**
 * Initial values for warehouse group form
 */
export const initialFormValues: WarehouseGroupFormValues = {
  ma_nhom: '',
  ten_phan_nhom: '',
  ten2: '',
  trang_thai: '1'
};

/**
 * Schema for warehouse group detail
 */
export const warehouseGroupDetailSchema = z.object({
  ma_nhom: z.string().min(1, 'Mã nhóm là bắt buộc'),
  ten_phan_nhom: z.string().min(1, 'Tên phân nhóm là bắt buộc'),
  ten2: z.string().optional().nullable(),
  trang_thai: z.string().default('active')
});

export type WarehouseGroupDetailFormValues = z.infer<typeof warehouseGroupDetailSchema>;
